import React from "react"

export default (props) => (
    <div>
        {props.name && props.email ? 
            <div id="profile" style={{display: "flex", flexDirection: "column", margin: "0 20px", alignItems: "center", justifyContent: 'center',}}>
                <b className="name">{props.name}</b>
                <i className="email">{props.email}</i>
            </div> : null
        }
    </div>
)


// WEBPACK FOOTER //
// ./src/components/export-google-sheet/components/profile/index.js